import { css } from '@emotion/react';

import CreditApplicationPageLayout from 'src/components/creditApplication/CreditApplicationPageLayout';
import GetHelpTextButton from 'src/components/creditApplication/GetHelpTextButton';

const AdverseActionPage = () => {
  return (
    <CreditApplicationPageLayout
      showLogo={false}
      icon='AlertFilled24'
      title='We are sorry'
      subtitle={
        <span>
          Unfortunately, based on the information provided, we were unable to open a Robinhood Gold Card account at this
          time. Please accept our apologies for the inconvenience.
          <br />
          <br />
          You will receive an email from us explaining our decision within 7 days.
        </span>
      }
    >
      <div css={root}>
        <GetHelpTextButton />
      </div>
    </CreditApplicationPageLayout>
  );
};

const root = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 24px;
`;

export default AdverseActionPage;
